import {
    resetLongDescription,
    setLongDescription as setLongDescriptionReducer,
    setLongDescriptionFromDraft as setLongDescriptionFromDraftReducer,
} from 'tradera/apps/syi/state/reducers/long-description';
import { updateDraftCanBeResumed } from './draft-actions';
import type {
    AppDispatch,
    GetState,
    RootState,
} from 'tradera/state/configure-store';
import { selectLongDescription } from 'tradera/apps/syi/state/selectors/syi';
import { createAsyncThunk } from '@reduxjs/toolkit';
import type {
    OffsitePaymentDetectionApiRequest,
    OffsitePaymentDetectionApiResponse,
} from 'tradera/state/services/types/webapi-selling-generated';
import { webApiClient } from 'tradera/utils/http';
import { selectIsFeatureEnabled } from 'tradera/state/environment/selectors';

export const setLongDescription =
    (longDescription: string) => (dispatch: AppDispatch) => {
        dispatch(setLongDescriptionReducer(longDescription));
        dispatch(updateDraftCanBeResumed());
    };

export const prependLongDescription =
    (longDescription: string) =>
    (dispatch: AppDispatch, getState: GetState) => {
        const currentLongDescription = selectLongDescription(getState());
        const newLongDescription = `${longDescription}\n\n${currentLongDescription}`;
        // Needs to be FromDraft, otherwise the update will not be shown
        // in the redactor-controlled textarea.
        dispatch(setLongDescriptionFromDraftReducer(newLongDescription));
        dispatch(updateDraftCanBeResumed());
    };

export const setLongDescriptionFromDraft =
    (longDescription: string) => (dispatch: AppDispatch) => {
        dispatch(setLongDescriptionFromDraftReducer(longDescription));
        dispatch(updateDraftCanBeResumed());
    };

export const reset = () => (dispatch: AppDispatch) => {
    dispatch(resetLongDescription());
    dispatch(updateDraftCanBeResumed());
};

export const fetchOffsitePaymentDetection = createAsyncThunk<
    OffsitePaymentDetectionApiResponse | null,
    OffsitePaymentDetectionApiRequest,
    {
        state: RootState;
    }
>(
    'syi/longDescription/fetchOffsitePaymentDetection',
    async (request: OffsitePaymentDetectionApiRequest, { getState }) => {
        const isOffsitePaymentDetectionEnabled = selectIsFeatureEnabled(
            'offsite-payment-detection',
        )(getState());

        if (isOffsitePaymentDetectionEnabled) {
            const { data } = await webApiClient.post<
                OffsitePaymentDetectionApiResponse,
                OffsitePaymentDetectionApiRequest
            >(`/selling/offsite-payment-detection`, request);
            return data;
        } else {
            return null;
        }
    },
);
